<div class="wrapper center">
  <div class="wrapper__icon-wrapper"><mat-icon>login</mat-icon></div>
  <div class="wrapper__title">Vous êtes en train de vous connecter en tant que {{ queryParams.managerEmail }}</div>

  <mat-spinner *ngIf="isLoading" [diameter]="35" [strokeWidth]="4"></mat-spinner>
</div>
